import * as Api from "@api";
import { CaptionedImage, Typography } from "@components";
import React from "react";
import styles from "./heating-consistency.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";

interface HeatingConsistencyProps
{
    compentitorCaption: Api.ContentItem;
    ownCaption: Api.ContentItem;
}

export const HeatingConsistency = ({ compentitorCaption, ownCaption }: HeatingConsistencyProps): React.FunctionComponentElement<HeatingConsistencyProps> =>
    <div className={styles["heating-consistency"]}>
        <VadImage src="/images/products/xl-poly/heating-consistency-1.png" width={93} height={471} alt="Heating Consistency" />
        <CaptionedImage
            captionProps={{ ...ownCaption, typography: Typography.H5 }}
            imageProps={{ src: "/images/products/xl-poly/heating-consistency-2.png", width: 377, height: 471, alt: "Heating Consistency" }}
        />
        <CaptionedImage
            captionProps={{ ...compentitorCaption, typography: Typography.H5 }}
            imageProps={{ src: "/images/products/xl-poly/heating-consistency-3.png", width: 377, height: 471, alt: "Heating Consistency" }}
        />
    </div>
